/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */

function CurrencyListing({currencyListingProps}) {
const {currencyRows,
    cashSales,
handleCashSaleChange
   }=currencyListingProps;


  return (
    <>
         {currencyRows.length>0?  <div className="cash-sales-section">
            <span className='large-button-text-medium'>Cash Sales by Currency</span>
             
             <div className="currency-grid sm-scrollbar margTop8"  style={{height:'30vh',overflowY:'scroll'}}>
               {currencyRows.map((row, rowIndex) => (
                 <div key={rowIndex} className="currency-row">
         
                     <div key={row} className="currency-field">
                       <label className={`${cashSales[row]>0 ? 'small-label-text' : ''}`}>{row}</label>
                     <input
                      type="number"
                      className={cashSales[row] > 0 ? 'edit-input-valuein' : 'edit-input'}
                      step="1"
                      value={cashSales[row] ?? ''}  
                      onChange={(e) => handleCashSaleChange(row, e.target.value)}
                      placeholder="0"
                      min="0"
                      />

                     </div>
                   
                 </div>
               ))}
             </div>
           </div>:<><h6>No Currencies found</h6></>}
    </>
  );
}

export default CurrencyListing;
